import { Clock, MapPin, Phone } from "lucide-react";

const ContactSection = () => {
  return (
    <section id="contact" className="py-16 md:py-24 bg-wiiseng-navy text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">Contact Us</h2>
          <p className="text-lg opacity-80 max-w-2xl mx-auto">
            Got a CNC machine that needs attention? Send us a WhatsApp and tell us what problem you're seeing.
          </p>
          <p className="text-lg opacity-80 max-w-2xl mx-auto">
            CNC机床需要维修或检查？欢迎通过 WhatsApp 联系我们，告诉我们您遇到的问题。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <div className="flex flex-col items-center justify-center text-center">
            <h3 className="text-2xl font-bold mb-6">Get in Touch</h3>
            <p className="text-white/80 mb-8">
              Share your machine model, alarm message, photos, or a short video so we can understand the issue faster.
            </p>
            <a 
              href="https://wa.me/60122443138" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg transition-colors text-lg"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Chat on WhatsApp
            </a>
          </div>
          
          <div className="flex flex-col justify-between">
            <div>
              <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-3">
                  <Phone className="h-5 w-5 mt-1 text-wiiseng-blue" />
                  <div>
                    <p className="font-semibold mb-1">Phone / WhatsApp</p>
                    <a href="https://wa.me/60122443138" className="text-white/80 hover:text-white">
                      +60 12 244 3138
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 mt-1 text-wiiseng-blue" />
                  <div>
                    <p className="font-semibold mb-1">Address</p>
                    <address className="not-italic text-white/80">
                      42, Jalan Sungai Merbau 32/89,<br />
                      Kota Kemuning, 40460 Shah Alam,<br />
                      Malaysia
                    </address>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <div className="flex items-center gap-2 mb-3">
                <Clock className="h-5 w-5 text-wiiseng-blue" />
                <p className="font-bold text-white/80">Business Hours</p>
              </div>
              <ul className="space-y-1 text-white/80">
                <li>Monday - Friday: 8:30 AM - 5:30 PM</li>
                <li>Saturday: 9:00 AM - 1:00 PM</li>
                <li>Sunday: Closed</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
